import React, {useEffect, useState} from "react";
import {selectCodesByParentId} from "../../../../../api/code/CodeService";
import {CompareMonthCells} from "./CompareMonthCells";
import {STICKY_TH} from "./slaCompareStickyClasses";

function CompareChildren({data, dateList}){

    const [code, setCode] = useState();
    const [structuredData, setStructuredData] = useState([]);

    useEffect(() => {
        selectCodesByParentId(16).then((response) => {
            const codeData = response;
            setCode(codeData);
            mapCodeWithChildren(codeData);
        });
    }, [data]);

    function mapCodeWithChildren(codeData) {
        if (!codeData || !data) return;

        const result = codeData.filter((codeItem) =>
            data.some((item) =>
                (item.children ?? item.availability ?? []).some(
                    (child) => child?.code?.id === codeItem.id,
                ),
            ),
        );

        setStructuredData(result);
    }

    return(
            <>
                <tr>
                    {structuredData && structuredData.length > 0 &&
                        <>
                            <th className={STICKY_TH.c1} rowSpan={structuredData.length * 5 + 1}>유지보수 서비스</th>
                            <th className={STICKY_TH.c2} rowSpan={structuredData.length * 5 + 1}>가동률</th>
                        </>
                    }
                </tr>
                {
                    structuredData && structuredData.map((code, index) => {
                        return (
                            <React.Fragment key={index}>
                                <tr>
                                    <th className={`${STICKY_TH.c3} truncate`} rowSpan={5}>{code.name}</th>
                                    <th className={STICKY_TH.c4}>가중치</th>
                                    <CompareMonthCells>
                                        {(monthData) => {
                                            const filtered = monthData?.children?.find((_) => (_.code?.id === code?.id));
                                            return filtered ? `${filtered.weight} %` : null;
                                        }}
                                    </CompareMonthCells>
                                </tr>
                                <tr>
                                    <th className={STICKY_TH.c4}>운영시간</th>
                                    <CompareMonthCells>
                                        {(monthData) => {
                                            const filtered = monthData?.children?.find((_) => (_.code?.id === code?.id));
                                            return filtered ? filtered.operationTimeKr : null;
                                        }}
                                    </CompareMonthCells>
                                </tr>
                                <tr>
                                    <th className={STICKY_TH.c4}>비계획된정지시간</th>
                                    <CompareMonthCells>
                                        {(monthData) => {
                                            const filtered = monthData?.children?.find((_) => (_.code?.id === code?.id));
                                            return filtered ? filtered.stopTimeKr : null;
                                        }}
                                    </CompareMonthCells>
                                </tr>
                                <tr>
                                    <th className={STICKY_TH.c4}>평가점수</th>
                                    <CompareMonthCells>
                                        {(monthData) => {
                                            const filtered = monthData?.children?.find((_) => (_.code?.id === code?.id));
                                            return filtered ? `${filtered.evaluationScore} %` : null;
                                        }}
                                    </CompareMonthCells>
                                </tr>
                                <tr>
                                    <th className={STICKY_TH.c4}>환산점수</th>
                                    <CompareMonthCells>
                                        {(monthData) => {
                                            const filtered = monthData?.children?.find((_) => (_.code?.id === code?.id));
                                            return filtered ? `${filtered.convertedScore} %` : null;
                                        }}
                                    </CompareMonthCells>
                                </tr>
                            </React.Fragment>
                        );
                    })
                }
            </>
    )
}

export {CompareChildren}
